import { AfterViewInit, Component, ComponentFactoryResolver, Input } from "@angular/core";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'reporteevaluacionpendientepreguntaenviadadetalle_personaevalua',
        templateUrl: './preguntaenviadadetalle_personaevalua.component.html',
    })

export class ReporteEvaluacionPendientePreguntaEnviadaDetallePersonaEvaluaComponent implements AfterViewInit{
    @Input() entidad!: any;
    @Input() accion!: any;
    @Input() listaevaluador!: any;

    consulta!:boolean;
    public abierto!: boolean;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
        this.abierto = true;
    }

}